import { useEffect, useState } from "react";
import type { Map as MapLibreMap } from "maplibre-gl";

export function useMapIcon(
  map: MapLibreMap | null,
  iconUrl: string,
  iconName: string
) {
  const [iconLoaded, setIconLoaded] = useState(false);

  useEffect(() => {
    if (!map) return;

    const loadIcon = async () => {
      try {
        const img = new Image();
        img.src = iconUrl;

        await new Promise<void>((resolve, reject) => {
          img.onload = () => resolve();
          img.onerror = () =>
            reject(new Error(`Failed to load icon: ${iconUrl}`));
        });

        if (!map.hasImage(iconName)) {
          map.addImage(iconName, img);
        }

        setIconLoaded(true);
      } catch (error) {
        console.error(error);
      }
    };

    loadIcon();
  }, [map, iconUrl, iconName]);

  return iconLoaded;
}
